<mat-tab-group class="positioning" [ngClass]="{ 'unset-z-index': modalIsShowing }">
    <mat-tab label="{{ 'MapViewer.Positioning.RealTimeGNSS' | translate }}">
        <rtc-panel (isModalShowing)="isModalShowing($event)"></rtc-panel>
    </mat-tab>
    <mat-tab label="{{ 'MapViewer.Positioning.OfflineGNSS' | translate }}">
        <post-processing-tab></post-processing-tab>
    </mat-tab>
</mat-tab-group>
